import {useEffect} from "react";
import {getCookie} from "@helpers/cookie/cookie";
import {LOCALES} from "@constants/locales";
import moment from "moment/moment";
import 'moment/dist/locale/uk'

export function useInitLocales(){

    useEffect(() => {
        const language = getCookie("language");
        const currentLocale = LOCALES.find((item) => item === language) ? language : 'uk'
        moment.updateLocale('uk', {
            week: {
                dow: 1,
            }
        });
        document.documentElement.setAttribute('lang', currentLocale)
    }, []);


}